import React from 'react';

import { FullPageLoaderWrapper, StyledDot, StyledLoader } from './styles';

export interface LoaderProps {
    centered?: boolean;
    backgroundColor?: string;
}

export const Loader: React.FC<LoaderProps> = ({
    centered = false,
    backgroundColor,
    ...rest
}) => {
    return (
        <StyledLoader centered={centered} aria-label="Please wait" {...rest}>
            <StyledDot
                {...(backgroundColor ? { style: { backgroundColor } } : {})}
            />
            <StyledDot
                {...(backgroundColor ? { style: { backgroundColor } } : {})}
            />
            <StyledDot
                {...(backgroundColor ? { style: { backgroundColor } } : {})}
            />
            <StyledDot
                {...(backgroundColor ? { style: { backgroundColor } } : {})}
            />
        </StyledLoader>
    );
};

export const FullPageLoader = () => (
    <FullPageLoaderWrapper>
        <Loader />
    </FullPageLoaderWrapper>
);
